// Catálogo de menu organizado por produto (PO1-1974).
//
// Cada produto (FLOW/GOBID/TRACKFY/AUTOPILOT/EVERLOG_ADMIN) tem sua própria
// árvore de menu. Itens compartilhados entre produtos são declarados como
// constantes e reusados nos slices relevantes (ex: TRANSPORTADORAS_ITEM aparece
// em FLOW, GOBID, TRACKFY — mesma URL, entrada replicada).
//
// Filtragem em Admin.js:
//   menu = PRODUCT_MENUS[activeProduct]
//   visíveis = menu.filter(item =>
//     hasFeature(item.requiredFeatures) AND  -- OR entre features
//     (isAdmin OR permissions.includes(item.authorized))
//   )
//
// Permissões: continuam usando o namespace 'Pages.HUB.*' do FLOW legado.
// A migração pra 'hub.*' (PO1-1947) está fora do escopo deste épico.
//
// URLs: continuam sem prefixo de produto. A migração pra /app/{produto}/* é
// PO1-1975 (próxima história).

import React from "react";

import Dashboard from "../views/Empresa/Dashboard";
import MeuPainel from "../views/Empresa/MeuPainel";
import DashboardAdmin from "../views/Admin/Dashboard";
import Autopilot from "../views/Autopilot";

// Operação
import AuditoriaCTe from "views/Empresa/AuditoriaCTe";
import ConsultaNotasFiscais from "views/Empresa/ConsultaNotasFiscais";
// Pesquisa de documentos (épico PO1-2280): consultas leves, somente leitura.
import PesquisaCte from "views/Empresa/PesquisaCte";
import ConferenciaFatura from "views/Empresa/ConferenciaFatura";
import VisaoFinanceiro from "views/Empresa/VisaoFinanceiro"; // PO1-3745 (sprint "Visão do Financeiro")
import AuditoriaPedido from "views/Empresa/AuditoriaPedido";
import Recalcular from "views/Empresa/Recalcular";
import Pedido from "views/Empresa/Pedido";
import ListagemCotacoes from "views/Empresa/ListagemCotacoes";
import NovaCotacaoManual from "views/Empresa/NovaCotacaoManual";
import CotacaoEmLote from "views/Empresa/CotacaoEmLote";
// "Cotações (legado)" (component GoBID) em descontinuação — removida do menu.
// Import e código mantidos por ora; remover de vez quando confirmado.
// import GoBID from "views/Empresa/GoBID";
import Sourcing from "views/Empresa/GoBID/Sourcing";
import Rastreamento from "views/Empresa/Tracking";
import EntregasPendentes from "views/Empresa/EntregasPendentes";
import CoberturaPrazo from "views/Trackfy/CoberturaPrazo";
import DespachoIndicadores from "views/Trackfy/DespachoIndicadores"; // PO1-3495 (épico PO1-3493)
// Documentos de frete / NFse (épico PO1-3298)
import RomaneioManual from "views/Empresa/RomaneioManual";
import DespachoLotes from "views/Empresa/DespachoLotes"; // PO1-2377 (épico PO1-2374)
import NfseSemNotas from "views/Empresa/NfseSemNotas";

import {
  GiMoebiusTriangle,
  GiTruck,
  GiSettingsKnobs,
} from "react-icons/gi";

import gobidIcon from "assets/img/gobid-icon-64.png";
import autopilotIcon from "assets/img/autopilot-mini-icon.png";

// Cadastros / shared
import Transportadoras from "views/Admin/Transportadoras";
import MinhasTransportadoras from "views/Empresa/Transportadoras/MinhasTransportadoras";
import CatalogoTransportadoras from "views/Empresa/Transportadoras/Catalogo";
import CertificadoDigital from "views/Empresa/CertificadoDigital";
import TabelasFrete from "views/Empresa/TabelasFrete";
import NovaTabelaFrete from "views/Empresa/NovaTabelaFrete";
import ImportFreteTabelaXlsm from "views/Empresa/GoBID/ImportFreteTabelaXlsm";
import Embarcadores from "views/Empresa/Embarcadores";
import CadastrosGerais from "views/Empresa/CadastrosGerais";
// O componente dedicado de CEP vive em outra branch (feat/crud-cep-frontend);
// usar CadastrosGerais como fallback até o PR do CEP ser merged em master.
import Modais from "views/Empresa/CadastrosGerais/Modais";
import Negocios from "views/Empresa/CadastrosGerais/Negocios";
import TiposServico from "views/Empresa/CadastrosGerais/TiposServico";
import TaxasFrete from "views/Empresa/CadastrosGerais/TaxasFrete";

import FreteTda from "views/Empresa/CadastrosGerais/FreteTda";
import VincularTipoServico from "views/Empresa/CadastrosGerais/VincularTipoServico";
import Holidays from "views/Admin/Holidays";
import ConectoresCatalogo from "views/Admin/ConectoresCatalogo";

// Indicadores
import IndicadorFaturamento from "views/Empresa/Indicadores/Faturamento";
import IndicadorEmissoes from "views/Empresa/Indicadores/Emissoes";
import IndicadorPisoAntt from "views/Empresa/Indicadores/PisoAntt";
import TabelaAntt from "views/Empresa/Indicadores/TabelaAntt";
import IndicadorSavingsGoBID from "views/Empresa/Indicadores/SavingsGoBID";
import IndicadorFilaFretesGoBID from "views/Empresa/Indicadores/FilaFretesGoBID";
import IndicadorCotadoRealizadoGoBID from "views/Empresa/Indicadores/CotadoRealizadoGoBID";
import LeiloesFrete from "views/Empresa/GoBID/Leiloes"; // PO1-3084 (épico PO1-3076)
import BidsFrete from "views/Empresa/GoBID/Bids"; // PO1-2841 (épico PO1-2413)
import PerfilEmbarcador from "views/Empresa/GoBID/Perfil"; // PO1-3529 (épico PO1-3527)
import IndicadorLeadTimeFatura from "views/Empresa/Indicadores/LeadTimeFatura";

// Sustentação / Integração
import UploadFilesTransporter from "views/Admin/UploadFilesTransporter";
import UploadFilesShipper from "views/Admin/UploadFilesShipper";
import Importacao from "views/Empresa/Importacao";
import LupaInconsistencias from "views/Empresa/LupaInconsistencias";
import CanaisRecepcao from "views/Empresa/CanaisRecepcao";

// Impostos
import TaxRatesState from "views/Admin/TaxRatesState";
import TaxRatesCounty from "views/Admin/TaxRatesCounty";

// Parâmetros
import ParametrosEmbarcador from "views/Empresa/Parametros";
import ParametrosTransportadora from "views/Empresa/Parametros/ParametrosTransportadora";
import ParametrosRemetente from "views/Empresa/Parametros/ParametrosRemetente";
import Integracoes from "views/Empresa/Integracoes";

// Gestão de Acessos
import Credenciais from "views/Admin/Credenciais";
import Users from "views/Admin/Users";
import Roles from "views/Admin/Roles";
import Settings from "views/Admin/Settings";

// Everlog Admin
import Companies from "views/Admin/Companies";
import OnboardingEmbarcador from "views/Admin/OnboardingEmbarcador";
import AcessoSftpTransportadora from "views/Admin/AcessoSftpTransportadora";
import CuradoriaTransportadoras from "views/Admin/CuradoriaTransportadoras";
import HomologacaoTransportadoras from "views/Admin/HomologacaoTransportadoras";
import RedeEverlogFunil from "views/Admin/RedeEverlogFunil"; // PO1-3649 (épico PO1-3359)
import Habilitacao from "views/Transportadora/Habilitacao";
import UsuariosPDT from "views/Admin/UsuariosPDT";
import CatalogoParametros from "views/Admin/Parametros";
import EcommerceIntegration from "views/Admin/EcommerceIntegration";
import Cronjobs from "views/Admin/Cronjobs";
import EmbarcadoresProdutos from "views/Admin/EmbarcadoresProdutos";
import Extrato from "views/Transportadora/Extrato";

// MeuFrete, o portal da transportadora (épico PO1-2285)
import MinhasFaturas from "views/Transportadora/MinhasFaturas";
import EnvioArquivos from "views/Transportadora/EnvioArquivos";
import TabelasEnviadas from "views/Transportadora/TabelasEnviadas";
import BidFreteTransportadora from "views/Transportadora/BidFrete"; // PO1-2847 (épico PO1-2413)
import CadastroTransportadora from "views/Transportadora/Cadastro";
import AcessoSftpMeuFrete from "views/Transportadora/AcessoSftp";
import TabelasEnviadasAdmin from "views/Admin/TabelasEnviadas";

// Motor de alertas (épico PO1-2194)
import MeusAlertas from "views/Alertas/MeusAlertas";
import MinhasTarefas from "views/Alertas/MinhasTarefas";
import AlertasCatalogo from "views/Admin/AlertasCatalogo";
import TiposVeiculo from "views/Admin/TiposVeiculo";
import CatalogoTutoriais from "views/Admin/CatalogoTutoriais";
import CentralTreinamento from "views/Treinamento/Central";
import AlertasUsuarios from "views/Acessos/AlertasUsuarios";
import { ALERTAS_SLUG_POR_PRODUTO } from "views/Alertas/alertasUtils";
import { TREINAMENTO_SLUG_POR_PRODUTO } from "views/Treinamento/rotas";

// ─── Códigos e ordem ─────────────────────────────────────────────────────────

export const PRODUCT_CODES = {
  FLOW: "FLOW",
  GOBID: "GOBID",
  TRACKFY: "TRACKFY",
  AUTOPILOT: "AUTOPILOT",
  EVERLOG_ADMIN: "EVERLOG_ADMIN",
  // PO1-2287: o produto da transportadora. Feature sintética que o backend só
  // manda para setor='transportadora' (/features/me).
  MEUFRETE: "MEUFRETE",
};

// Ordem do app switcher e do fallback de produto ativo (vide
// hooks/activeProduct.js).
export const PRODUCT_ORDER = [
  PRODUCT_CODES.FLOW,
  PRODUCT_CODES.GOBID,
  PRODUCT_CODES.TRACKFY,
  PRODUCT_CODES.AUTOPILOT,
  PRODUCT_CODES.EVERLOG_ADMIN,
  PRODUCT_CODES.MEUFRETE,
];

// Ícones por produto — componentes react-icons renderizados no AppSwitcher.
// Produto sem ícone (icon: null) cai num placeholder neutro.
export const PRODUCT_META = {
  [PRODUCT_CODES.FLOW]: { label: "Flow", color: "#1d8cf8", icon: GiMoebiusTriangle },
  [PRODUCT_CODES.GOBID]: { label: "GoBid", color: "#00bf9a", icon: null, iconImage: gobidIcon },
  [PRODUCT_CODES.TRACKFY]: { label: "Trackfy", color: "#ff8d72", icon: GiTruck },
  [PRODUCT_CODES.AUTOPILOT]: { label: "Autopilot", color: "#e14eca", icon: null, iconImage: autopilotIcon },
  [PRODUCT_CODES.EVERLOG_ADMIN]: { label: "Everlog Admin", color: "#fd5d93", icon: GiSettingsKnobs },
  [PRODUCT_CODES.MEUFRETE]: { label: "MeuFrete", color: "#00f2c3", icon: GiTruck },
};

// Sprint 638: CEP e Modais em modo consulta nos produtos do
// cliente (a edição fica no Everlog Admin › Cadastros globais). Componentes
// estáveis no módulo para o React não remontar a tela a cada render.
const CepConsulta = (props) => React.createElement(CadastrosGerais, { ...props, somenteLeitura: true });
CepConsulta.displayName = "CepConsulta";
const ModaisConsulta = (props) => React.createElement(Modais, { ...props, somenteLeitura: true });
ModaisConsulta.displayName = "ModaisConsulta";
// PO1-3836: Tipo de Serviço deixa de ser só consulta; no cliente edita os tipos do
// embarcador, no Everlog Admin mantém os padrões e vê todos.
const TiposServicoAdmin = (props) => React.createElement(TiposServico, { ...props, modo: "admin" });
TiposServicoAdmin.displayName = "TiposServicoAdmin";

// ─── Itens compartilhados (declarados uma vez, reusados em vários produtos) ─

const SHARED_AUTOPILOT = {
  path: "/autopilot",
  name: "Autopilot",
  iconImage: autopilotIcon,
  component: Autopilot,
  layout: "/app",
  // PO1-2194: exato porque o produto AUTOPILOT tem /autopilot/alertas e
  // /autopilot/tarefas; sem isto o Switch casaria o prefixo e abriria o
  // Autopilot no lugar delas. /app/autopilot/chat é rota fixa no layout.
  // `matchExact` aplica o mesmo casamento exato no breadcrumb e no destaque do
  // menu lateral, só para este item (os demais `exact` seguem como antes).
  exact: true,
  matchExact: true,
  authorized: "Pages.HUB.Dashboard",
  requiredFeatures: ["AUTOPILOT"],
};

// Cadastro mestre GLOBAL de transportadora (views/Admin/Transportadoras): editar
// ali muda o registro para todos os embarcadores. PO1-3168: saiu dos menus de
// produto do embarcador (FLOW/GOBID/TRACKFY) e vive como filho de
// ADMIN_GRUPO_TRANSPORTADORAS, no Everlog Admin. Sem `requiredFeatures` próprio: o
// gate é o do grupo (EVERLOG_ADMIN), e `isAdmin` NÃO faz bypass de feature — se
// este item mantivesse ["FLOW","GOBID","TRACKFY"], um admin sem esses produtos
// deixaria de ver a tela. `mini` no lugar de `icon`, como os irmãos do grupo. O
// path fica o mesmo para o redirect legado de LEGACY_REDIRECTS continuar valendo.
const ADMIN_CADASTRO_TRANSPORTADORAS = {
  path: "/cadastros/transportadoras",
  name: "Cadastro",
  mini: "CAD",
  component: Transportadoras,
  layout: "/app",
  authorized: "Pages.HUB.Transportadoras",
};

// Gestão de Transportadoras pelo embarcador (PO1-2620): Minhas Transportadoras
// + Catálogo. É o grupo do EMBARCADOR; o cadastro mestre
// (ADMIN_CADASTRO_TRANSPORTADORAS) é do admin e mora no Everlog Admin desde a
// PO1-3168 — os dois não competem mais pelo nome "Transportadoras" no menu.
// requiredFeatures ["FLOW","GOBID","TRACKFY"] (não isolado a ["FLOW"]): o
// gancho comercial de SFTP (H5) precisa alcançar embarcadores sem FLOW.
//
// Permissão PRÓPRIA (hub.transportadoras.carteira, catálogo em
// backend_hub/src/app/auth/HubPermissions.js), NÃO reusa Pages.HUB.Transportadoras
// — achado ao vivo em QA: essa permissão legada também gate o cadastro GLOBAL
// de transportadora (compartilhado entre todos os embarcadores). Conceder ela a
// uma role de embarcador só pra liberar estas 2 telas destravava, sem querer,
// editar/criar/apagar o cadastro mestre de qualquer transportadora do sistema
// — risco de dado, não só de UI.
const SHARED_GESTAO_TRANSPORTADORAS = {
  collapse: true,
  name: "Conexões",
  icon: "tim-icons icon-bus-front-12",
  state: "gestaoTransportadorasCollapse",
  views: [
    {
      path: "/transportadoras/minhas",
      name: "Minhas Transportadoras",
      mini: "MIN",
      component: MinhasTransportadoras,
      layout: "/app",
      authorized: "hub.transportadoras.carteira",
    },
    {
      path: "/transportadoras/catalogo",
      name: "Catálogo",
      mini: "CAT",
      component: CatalogoTransportadoras,
      layout: "/app",
      authorized: "hub.transportadoras.carteira",
    },
    // Certificado A1 do embarcador para a captura direta na SEFAZ (PO1-3008 /
    // épico PO1-3002). Mora em "Conexões" porque é mais uma fonte externa de
    // CT-e, ao lado do SFTP das transportadoras. Reusa a permissão da carteira
    // (quem decide com quais transportadoras o embarcador se conecta decide
    // também esta conexão); permissão própria só se o Rodrigo pedir.
    {
      path: "/certificado-digital",
      name: "Certificado Digital",
      mini: "CRT",
      component: CertificadoDigital,
      layout: "/app",
      authorized: "hub.transportadoras.carteira",
    },
  ],
  requiredFeatures: ["FLOW", "GOBID", "TRACKFY"],
};

const SHARED_TABELAS_FRETE = {
  collapse: true,
  name: "Tabelas de Frete",
  icon: "tim-icons icon-money-coins",
  state: "tabelasFreteCollapse",
  views: [
    {
      path: "/cadastros/tabelas-frete",
      name: "Listagem",
      mini: "TBF",
      component: TabelasFrete,
      layout: "/app",
      authorized: "Pages.Recalculo",
      exact: true, // senão o Switch casa esse prefixo antes de /nova e /importar
    },
    {
      path: "/cadastros/tabelas-frete/nova",
      name: "Nova Tabela",
      mini: "NTF",
      component: NovaTabelaFrete,
      layout: "/app",
      authorized: "Pages.Recalculo",
    },
    {
      path: "/cadastros/tabelas-frete/importar",
      name: "Importar XLSM",
      mini: "ITX",
      component: ImportFreteTabelaXlsm,
      layout: "/app",
      authorized: "Pages.HUB.Flow.UploadFreteTabela",
    },
    {
      // PO1-3066: Taxa de Dificuldade de Entrega (FreteTda), cobrada por CPF/CNPJ do
      // destinatário (TDA, TDE, TRT, descarga, agendamento). Fica em Tabelas de Frete
      // porque compõe o preço do frete, não é catálogo geral. Permissão própria,
      // herdada do legado e já concedida aos perfis 8, 10, 15, 16 e 17.
      path: "/cadastros/frete-tda",
      name: "Taxa de Dificuldade de Entrega",
      mini: "TDA",
      component: FreteTda,
      layout: "/app",
      authorized: "Pages.Cadastro.FreteTda",
    },
  ],
  requiredFeatures: ["FLOW", "GOBID"],
};

// Sprint 638: o cadastro do embarcador ganhou as abas Origens / CDs e Contatos
// (que eram itens de Parâmetros). A rota libera com qualquer uma das três
// permissões e cada aba confere a sua dentro da tela (EmbarcadorCadastro).
const SHARED_EMBARCADORES = {
  path: "/cadastros/embarcadores",
  name: "Embarcadores",
  icon: "tim-icons icon-bank",
  component: Embarcadores,
  layout: "/app",
  authorized: ["Pages.Cadastro.Embarcador", "hub.operacao.pedidos.visualizar", "hub.embarcadores.contatos"],
  requiredFeatures: ["FLOW", "GOBID", "TRACKFY"],
};

const SHARED_CADASTROS_GERAIS = {
  collapse: true,
  name: "Cadastros Gerais",
  icon: "tim-icons icon-book-bookmark",
  state: "cadastrosGeraisCollapse",
  views: [
    // CEP, Modais e Tipo de Serviço são cadastros GLOBAIS (valem para todos os
    // clientes): aqui só consulta; a edição fica no Everlog Admin › Cadastros
    // globais e o backend nega a escrita a quem não é admin Everlog (sprint 638).
    // Mesmo o admin vê só consulta neste menu, para editar no lugar certo.
    {
      path: "/cadastros/cep",
      name: "CEP",
      mini: "CEP",
      component: CepConsulta,
      layout: "/app",
      authorized: "Pages.Cadastro.CEP",
    },
    {
      path: "/cadastros/modais",
      name: "Modais",
      mini: "MOD",
      component: ModaisConsulta,
      layout: "/app",
      authorized: "Pages.Cadastro.Modal",
    },
    {
      path: "/cadastros/negocios",
      name: "Negócios",
      mini: "NEG",
      component: Negocios,
      layout: "/app",
      authorized: "Pages.Cadastro.Negocio",
    },
    // Tipo de Serviço por embarcador (PO1-3836): padrões Everlog + os tipos do
    // embarcador do topo, que o cliente cadastra. Taxas de Frete saiu daqui: o
    // cliente só escolhe taxa ao montar a tabela de frete.
    {
      path: "/cadastros/tipos-servico",
      name: "Tipo de Serviço",
      mini: "TPS",
      component: TiposServico,
      layout: "/app",
      authorized: "Pages.Cadastro.TipoServico",
    },
    {
      path: "/cadastros/vincular-tipo-servico",
      name: "Vincular Tipo de Serviço",
      mini: "VTS",
      component: VincularTipoServico,
      layout: "/app",
      authorized: "Pages.Cadastro.VincularTipoServico",
    },
  ],
  requiredFeatures: ["FLOW", "GOBID", "TRACKFY"],
};

const TRACKFY_FERIADOS = {
  path: "/cadastros/feriados",
  name: "Feriados",
  icon: "tim-icons icon-calendar-60",
  component: Holidays,
  layout: "/app",
  authorized: "Pages.Cadastro.Feriado",
  requiredFeatures: ["TRACKFY"],
};

// Catálogo de conectores do embarcador (épico PO1-3258, H3/H4). Fica logo antes
// de Parâmetros nos três produtos: os conectores SÃO parâmetros do embarcador, mas
// ganharam tela própria (ativar/configurar/testar) e saíram da tela genérica.
const SHARED_INTEGRACOES = {
  collapse: true,
  name: "Integrações",
  icon: "tim-icons icon-link-72",
  state: "integracoesCollapse",
  views: [
    {
      path: "/integracoes",
      name: "Catálogo",
      mini: "INT",
      component: Integracoes,
      layout: "/app",
      authorized: "Pages.Parametro.EmbarcadorParametro",
    },
  ],
  requiredFeatures: ["FLOW", "GOBID", "TRACKFY"],
};

const SHARED_PARAMETROS = {
  collapse: true,
  name: "Parâmetros",
  icon: "tim-icons icon-settings-gear-63",
  state: "parametrosCollapse",
  views: [
    {
      path: "/configuracoes/parametros-embarcador",
      name: "Embarcador",
      mini: "EMB",
      component: ParametrosEmbarcador,
      layout: "/app",
      authorized: "Pages.Parametro.EmbarcadorParametro",
    },
    // Contatos (PO1-3384) e Origens / CDs (PO1-2380) viraram abas do cadastro
    // do embarcador na sprint 638; os paths antigos redirecionam (LEGACY_REDIRECTS).
    {
      path: "/configuracoes/parametros-transportadora",
      name: "Transportadora",
      mini: "TRP",
      component: ParametrosTransportadora,
      layout: "/app",
      authorized: "Pages.Parametro.EmbarcadorTransportadoraParametro",
    },
    {
      path: "/configuracoes/parametros-remetente",
      name: "Remetente",
      mini: "REM",
      component: ParametrosRemetente,
      layout: "/app",
      authorized: "Pages.Parametro.EmbarcadorRemetenteParametro",
    },
  ],
  requiredFeatures: ["FLOW", "GOBID", "TRACKFY"],
};

const SHARED_ACESSOS = {
  collapse: true,
  name: "Gestão de Acessos",
  icon: "tim-icons icon-single-02",
  state: "gestaoAcessosCollapse",
  views: [
    {
      path: "/acessos/usuarios",
      name: "Gerenciar Usuários",
      mini: "USR",
      component: Users,
      layout: "/app",
      authorized: "Pages.HUB.Users",
    },
    // PO1-3295: "Gerenciar Grupos" e "Configurações" foram para o Everlog
    // Admin (ADMIN_GRUPO_AJUSTES): grupos e configurações valem para todos os
    // clientes e só a Everlog altera.
    // PO1-2194: o admin do embarcador escolhe os alertas de cada usuário.
    {
      path: "/acessos/alertas",
      name: "Alertas dos usuários",
      mini: "ALE",
      component: AlertasUsuarios,
      layout: "/app",
      authorized: "hub.alertas.inscricoes.gerenciar",
    },
  ],
  requiredFeatures: ["FLOW", "GOBID", "TRACKFY"],
};

// ─── Alertas por produto (PO1-2194) ─────────────────────────────────────────
// "Meus alertas" e "Minhas tarefas" aparecem no fim do menu de cada produto com
// o slug dele no path (/app/<slug>/alertas). Sem `authorized`: todo usuário do
// produto tem os próprios alertas; o gate é só a feature. `component` injeta o
// código do produto, que as telas usam para filtrar a API.
// Cache por código: o `component` precisa ser estável entre renders do layout.
const ALERTAS_COMPONENTES = {};

function componenteComProduto(Tela, code, nome) {
  const chave = `${nome}:${code}`;
  if (!ALERTAS_COMPONENTES[chave]) {
    const Comp = (props) => React.createElement(Tela, { ...props, produto: code });
    Comp.displayName = `${nome}(${code})`;
    ALERTAS_COMPONENTES[chave] = Comp;
  }
  return ALERTAS_COMPONENTES[chave];
}

export function makeAlertasItens(code) {
  const slug = ALERTAS_SLUG_POR_PRODUTO[code];
  if (!slug) return [];
  // Um grupo só no menu (pedido do Rodrigo na sprint 638): os paths não mudam,
  // então os links do sino (AlertasSino) seguem iguais.
  return [
    {
      collapse: true,
      name: "Alertas e tarefas",
      icon: "tim-icons icon-bell-55",
      state: "alertasTarefasCollapse",
      requiredFeatures: [code],
      views: [
        {
          path: `/${slug}/alertas`,
          name: "Meus alertas",
          mini: "ALE",
          component: componenteComProduto(MeusAlertas, code, "MeusAlertas"),
          layout: "/app",
          requiredFeatures: [code],
        },
        {
          path: `/${slug}/tarefas`,
          name: "Minhas tarefas",
          mini: "TAR",
          component: componenteComProduto(MinhasTarefas, code, "MinhasTarefas"),
          layout: "/app",
          requiredFeatures: [code],
        },
      ],
    },
  ];
}

// ─── Central de Treinamento por produto (PO1-3505, épico PO1-3504) ──────────
// "Treinamento" entra no fim do menu de cada produto, ANTES dos alertas, com o
// slug dele no path (/app/<slug>/treinamento). Sem `authorized`: o servidor
// filtra os tutoriais por produto e permissão (a Central nunca mostra o que o
// usuário não pode usar). `component` injeta o código do produto, que a tela
// manda na consulta. No Everlog Admin a Central mostra todos os tutoriais.
export function makeTreinamentoItem(code) {
  const slug = TREINAMENTO_SLUG_POR_PRODUTO[code];
  if (!slug) return null;
  return {
    path: `/${slug}/treinamento`,
    name: "Treinamento",
    icon: "tim-icons icon-video-66",
    component: componenteComProduto(CentralTreinamento, code, "CentralTreinamento"),
    layout: "/app",
    requiredFeatures: [code],
  };
}

// ─── Itens exclusivos por produto ────────────────────────────────────────────

const FLOW_DASHBOARD = {
  path: "/flow/dashboard",
  name: "Torre de Controle",
  icon: "tim-icons icon-chart-bar-32",
  component: Dashboard,
  layout: "/app",
  authorized: "Pages.HUB.Dashboard",
  requiredFeatures: ["FLOW"],
};

// Meu Painel (PO1-3439): painel montado pelo usuário com os gráficos da Torre de
// Controle. Mesmo grant da Torre; entra logo abaixo dela em cada produto.
const FLOW_MEU_PAINEL = {
  path: "/flow/meu-painel",
  name: "Meu Painel",
  icon: "tim-icons icon-puzzle-10",
  component: MeuPainel,
  layout: "/app",
  authorized: "Pages.HUB.Dashboard",
  requiredFeatures: ["FLOW"],
};

// Consultas (31/10/2026): telas somente leitura de documentos, separadas da
// Operação (onde se audita e age). A Consulta NFe absorveu a Pesquisa Importação
// (PO1-2967) e a Pesquisa CT-e virou Consulta CT-e; os paths ficaram em
// /flow/operacao/ para não quebrar favoritos e links já enviados.
const FLOW_CONSULTAS = {
  collapse: true,
  name: "Consultas",
  icon: "tim-icons icon-zoom-split",
  state: "flowConsultasCollapse",
  views: [
    {
      path: "/flow/operacao/notas-fiscais",
      // A permissao do FLOW usa underscore antes de NotasFiscais. Com ponto o
      // nome nao casa com nenhuma linha de AbpPermissions e o item some do menu
      // para todo usuario que nao seja do setor admin.
      name: "Consulta NFe",
      mini: "NFE",
      component: ConsultaNotasFiscais,
      layout: "/app",
      authorized: "Pages.HUB.Monitoramento_NotasFiscais",
    },
    {
      // Épico PO1-2280 (PO1-2968): consulta leve de CT-e, sem OK/NOK nem
      // conciliação; também é a consulta de CT-e do Smartdash (PO1-3464).
      // Permissão do monitoramento de CT-e do FLOW (com ponto, como está em
      // AbpPermissions), já concedida aos perfis que usam a Consulta NFe.
      path: "/flow/operacao/pesquisa-cte",
      name: "Consulta CTE",
      mini: "CCT",
      component: PesquisaCte,
      layout: "/app",
      authorized: "Pages.HUB.Monitoramento.Cets",
    },
  ],
  requiredFeatures: ["FLOW"],
};

const FLOW_OPERACAO = {
  collapse: true,
  name: "Operação",
  icon: "tim-icons icon-bullet-list-67",
  state: "flowOperacaoCollapse",
  views: [
    {
      path: "/flow/operacao/auditoria-cte",
      name: "Auditoria CTE",
      mini: "CTE",
      component: AuditoriaCTe,
      layout: "/app",
      authorized: "Pages.Recalculo",
    },
    {
      path: "/flow/operacao/auditoria-faturas",
      name: "Auditoria Fatura",
      mini: "FAT",
      component: ConferenciaFatura,
      layout: "/app",
      // RBAC hub.* (PO1-2180). Não-admin precisa do grant
      // hub.fatura.conferencia.visualizar; admin Everlog tem bypass.
      authorized: "hub.fatura.conferencia.visualizar",
    },
    {
      // PO1-3240: cotado × conferido × cobrado de um pedido (?pedido=X). Mesma
      // permissão da Auditoria de Faturas; o grupo já exige o produto FLOW.
      path: "/flow/operacao/auditoria-pedido",
      name: "Auditoria Pedido",
      mini: "PED",
      component: AuditoriaPedido,
      layout: "/app",
      authorized: "hub.fatura.conferencia.visualizar",
    },
    {
      path: "/flow/operacao/recalcular",
      name: "Recalcular Frete",
      mini: "REC",
      component: Recalcular,
      layout: "/app",
      authorized: "Pages.Recalculo",
    },
  ],
  requiredFeatures: ["FLOW"],
};

// Financeiro (PO1-3745, sprint "Visão do Financeiro"): as faturas do embarcador
// em Pendente / Liberado para pagar / Pago, com totais, "Marcar como paga" e o
// relatório em PDF. Pedido do financeiro da Arneg (27/10/2026): uma visão só com
// o que ele precisa, separada da Auditoria Fatura. Item de primeiro nível, entre
// Operação e Despacho. Permissão própria (hub.fatura.financeiro.visualizar), dada
// pelo perfil "Embarcador | Financeiro" ou por usuário; admin Everlog tem bypass.
const FLOW_FINANCEIRO = {
  path: "/flow/financeiro",
  name: "Financeiro",
  icon: "tim-icons icon-money-coins",
  component: VisaoFinanceiro,
  layout: "/app",
  authorized: "hub.fatura.financeiro.visualizar",
  requiredFeatures: ["FLOW"],
};

// Despacho (épico PO1-3298): o que sai do embarcador para a transportadora,
// agrupado como no mercado (romaneio, lote de despacho, coleta). Começou com o
// Romaneio (PO1-3300), cadastro igual ao do legado (Frete Lotação → Romaneio)
// com o vínculo das notas fiscais. O que o mercado chama de PLP virou o lote
// de despacho (PO1-2377, épico PO1-2374): agrupa os envios com etiqueta emitida
// por transportadora, fecha por gatilho (horário/volume) ou à mão, gera
// manifesto e NOTFIS e despacha com pedido de coleta. A fatura manual
// (PO1-3307) não é tela própria: é o botão "Nova fatura" da Auditoria de Faturas.
const FLOW_DESPACHO = {
  collapse: true,
  name: "Despacho",
  icon: "tim-icons icon-delivery-fast",
  state: "flowDespachoCollapse",
  views: [
    {
      path: "/flow/despacho/romaneio",
      name: "Romaneio",
      mini: "ROM",
      component: RomaneioManual,
      layout: "/app",
      authorized: "hub.romaneio.manual.visualizar",
    },
    // PO1-2377: lotes de despacho (abertos / fechados / despachados / com erro).
    // Leitura com hub.operacao.despacho.visualizar; as ações de escrita
    // (hub.operacao.despacho.editar) ficam escondidas dentro da tela.
    {
      path: "/flow/despacho/lotes",
      name: "Lotes",
      mini: "LOT",
      component: DespachoLotes,
      layout: "/app",
      authorized: "hub.operacao.despacho.visualizar",
    },
  ],
  requiredFeatures: ["FLOW"],
};

const FLOW_INDICADORES = {
  collapse: true,
  name: "Indicadores",
  icon: "tim-icons icon-chart-pie-36",
  state: "indicadoresCollapse",
  views: [
    {
      path: "/flow/indicadores/faturamento",
      name: "Faturamento",
      mini: "FAT",
      component: IndicadorFaturamento,
      layout: "/app",
      authorized: "Pages.HUB.Indicadores.Faturamento",
    },
    {
      path: "/flow/indicadores/emissoes-carbono",
      name: "Emissões CO₂",
      mini: "CO₂",
      component: IndicadorEmissoes,
      layout: "/app",
      // Reusa permissão de Faturamento até PO1-1947 adicionar a específica
      authorized: "Pages.HUB.Indicadores.Faturamento",
    },
    {
      path: "/flow/indicadores/piso-antt",
      name: "Piso Mínimo ANTT",
      mini: "ANTT",
      component: IndicadorPisoAntt,
      layout: "/app",
      // Reusa permissão de Faturamento (mesmo critério das emissões)
      authorized: "Pages.HUB.Indicadores.Faturamento",
    },
    {
      path: "/flow/indicadores/tabela-antt",
      name: "Tabela ANTT",
      mini: "TAB",
      component: TabelaAntt,
      layout: "/app",
      authorized: "Pages.HUB.Indicadores.Faturamento",
    },
    {
      path: "/flow/indicadores/lead-time-fatura",
      name: "Lead Time Fatura",
      mini: "LT",
      component: IndicadorLeadTimeFatura,
      layout: "/app",
      // Lê as faturas da conferência: mesma permissão da Auditoria de Faturas.
      authorized: "hub.fatura.conferencia.visualizar",
    },
  ],
  requiredFeatures: ["FLOW"],
};

const FLOW_SUSTENTACAO = {
  collapse: true,
  name: "Sustentação",
  icon: "tim-icons icon-upload",
  state: "flowSustentacaoCollapse",
  views: [
    {
      path: "/flow/sustentacao/upload-transportador",
      name: "Upload Transportador",
      mini: "UPT",
      component: UploadFilesTransporter,
      layout: "/app",
      authorized: "Pages.HUB.Sustentacao.UploadTransportador",
    },
    {
      path: "/flow/sustentacao/upload-embarcador",
      name: "Upload Embarcador",
      mini: "UPE",
      component: UploadFilesShipper,
      layout: "/app",
      authorized: "Pages.HUB.Sustentacao.UploadEmbarcador",
    },
    {
      path: "/flow/sustentacao/importacao",
      name: "Integração",
      mini: "INT",
      component: Importacao,
      layout: "/app",
      // Admin tem bypass; usuário comum precisa do grant desta string
      authorized: "Pages.HUB.Sustentacao.Importacao",
    },
    {
      path: "/flow/sustentacao/lupa-inconsistencias",
      name: "Lupa de Inconsistências",
      mini: "LUP",
      component: LupaInconsistencias,
      layout: "/app",
      // Mesma fila da Integração: mesmo grant, sem permissão nova a conceder.
      authorized: "Pages.HUB.Sustentacao.Importacao",
    },
    {
      path: "/flow/sustentacao/canais-recepcao",
      name: "Canais de recepção",
      mini: "CAN",
      component: CanaisRecepcao,
      layout: "/app",
      // Grant novo, mesmo padrão dos irmãos (conceder ao perfil "Embarcador | Administrador")
      authorized: "Pages.HUB.Sustentacao.CanaisRecepcao",
    },
    {
      // PO1-3301 (épico PO1-3298): NFse sem vínculo com NF; associa as notas
      // (por romaneio ou remetente × período). Saiu de Operação para o fim de
      // Sustentação (pedido do Rodrigo, 06/10/2026); o path antigo redireciona.
      path: "/flow/sustentacao/nfse-sem-notas",
      name: "NFse sem notas",
      mini: "NFS",
      component: NfseSemNotas,
      layout: "/app",
      authorized: "hub.nfse.visualizar",
    },
  ],
  requiredFeatures: ["FLOW"],
};

const FLOW_IMPOSTOS = {
  collapse: true,
  name: "Impostos",
  icon: "tim-icons icon-coins",
  state: "fiscalCollapse",
  views: [
    {
      path: "/flow/fiscal/tributos-estaduais",
      name: "Tributos Estaduais",
      mini: "TES",
      component: TaxRatesState,
      layout: "/app",
      authorized: "Pages.Cadastro.TributoEstadual",
    },
    {
      path: "/flow/fiscal/tributos-municipais",
      name: "Tributos Municipais",
      mini: "TMU",
      component: TaxRatesCounty,
      layout: "/app",
      authorized: "Pages.Cadastro.TributoMunicipal",
    },
  ],
  requiredFeatures: ["FLOW"],
};

const GOBID_DASHBOARD = {
  ...FLOW_DASHBOARD,
  path: "/gobid/dashboard",
  requiredFeatures: ["GOBID"],
};

const GOBID_MEU_PAINEL = {
  ...FLOW_MEU_PAINEL,
  path: "/gobid/meu-painel",
  requiredFeatures: ["GOBID"],
};

const GOBID_OPERACAO = {
  collapse: true,
  name: "Operação",
  icon: "tim-icons icon-delivery-fast",
  state: "gobidOperacaoCollapse",
  views: [
    {
      path: "/gobid/operacao/listagem-cotacoes",
      name: "Minhas Cotações",
      mini: "MIN",
      component: ListagemCotacoes,
      layout: "/app",
      authorized: "Pages.HUB.GoBID",
    },
    {
      path: "/gobid/operacao/nova-cotacao",
      name: "Cotação Individual",
      mini: "IND",
      component: NovaCotacaoManual,
      layout: "/app",
      authorized: "Pages.HUB.GoBID",
    },
    {
      path: "/gobid/operacao/cotacao-em-lote",
      name: "Cotação em Lote",
      mini: "LOT",
      component: CotacaoEmLote,
      layout: "/app",
      authorized: "Pages.HUB.GoBID",
    },
    {
      // PO1-3084 (épico PO1-3076): Leilão Reverso de Frete — oferta com
      // preço-alvo e janela, lances das transportadoras, vencedora vira cotação.
      path: "/gobid/operacao/leiloes",
      name: "Leilões",
      mini: "LEI",
      component: LeiloesFrete,
      layout: "/app",
      authorized: "Pages.HUB.GoBID",
    },
    {
      // PO1-2841 (épico PO1-2413): BID de Frete — recalcula as NFs reais de um
      // período com todas as candidatas e compara com o cobrado (Benchmark/RFP).
      path: "/gobid/operacao/bids",
      name: "BID de Frete",
      mini: "BID",
      component: BidsFrete,
      layout: "/app",
      authorized: "Pages.HUB.GoBID",
    },
    {
      // PO1-2437: descoberta de transportadoras por destino (Epic PO1-2434)
      path: "/gobid/operacao/sourcing",
      name: "Sourcing",
      mini: "SRC",
      component: Sourcing,
      layout: "/app",
      authorized: "Pages.HUB.GoBID",
    },
    {
      // PO1-3529 (épico PO1-3527): o que as transportadoras de fora da carteira
      // veem sobre o embarcador no convite do leilão e do BID.
      path: "/gobid/operacao/perfil",
      name: "Perfil do embarcador",
      mini: "PRF",
      component: PerfilEmbarcador,
      layout: "/app",
      authorized: "Pages.HUB.GoBID",
    },
    {
      // PO1-3629 (épico PO1-3620): a Fila de Fretes é tela de trabalho, não
      // indicador — saiu de "Dashboards" para Operação (padrão olhar/explorar/
      // agir). A URL antiga /gobid/dashboards/fila-fretes redireciona para cá.
      path: "/gobid/operacao/fila-fretes",
      name: "Fila de Fretes",
      mini: "FILA",
      component: IndicadorFilaFretesGoBID,
      layout: "/app",
      authorized: "Pages.HUB.GoBID",
    },
    // "Cotações (legado)" (component GoBID) removida do menu — em descontinuação.
    // Mantida comentada (não apagada) p/ observar impacto antes da remoção final.
    // {
    //   path: "/gobid/operacao/gobid-legado",
    //   name: "Cotações (legado)",
    //   mini: "OLD",
    //   component: GoBID,
    //   layout: "/app",
    //   authorized: "Pages.HUB.GoBID",
    // },
  ],
  requiredFeatures: ["GOBID"],
};

// Indicadores do GoBID (PO1-2589, renomeado de "Dashboards" na PO1-3629 para
// seguir o padrão do Flow e do Trackfy: indicador em "Indicadores", tela de
// trabalho em "Operação"). As URLs antigas /gobid/dashboards/* redirecionam.
const GOBID_INDICADORES = {
  collapse: true,
  name: "Indicadores",
  icon: "tim-icons icon-chart-pie-36",
  state: "gobidIndicadoresCollapse",
  views: [
    {
      path: "/gobid/indicadores/savings",
      name: "Savings",
      mini: "SAV",
      component: IndicadorSavingsGoBID,
      layout: "/app",
      authorized: "Pages.HUB.GoBID",
    },
    {
      // PO1-3621 (épico PO1-3620): frete cotado × frete realizado por
      // transportadora, UF e período, com o valor da mercadoria e o ano anterior.
      path: "/gobid/indicadores/cotado-realizado",
      name: "Cotado × Realizado",
      mini: "CXR",
      component: IndicadorCotadoRealizadoGoBID,
      layout: "/app",
      authorized: "Pages.HUB.GoBID",
      requiredFeatures: ["GOBID"],
    },
  ],
  requiredFeatures: ["GOBID"],
};

const TRACKFY_DASHBOARD = {
  ...FLOW_DASHBOARD,
  path: "/trackfy/dashboard",
  requiredFeatures: ["TRACKFY"],
};

const TRACKFY_MEU_PAINEL = {
  ...FLOW_MEU_PAINEL,
  path: "/trackfy/meu-painel",
  requiredFeatures: ["TRACKFY"],
};

const TRACKFY_OPERACAO = {
  collapse: true,
  name: "Operação",
  icon: "tim-icons icon-cart",
  state: "trackfyOperacaoCollapse",
  views: [
    {
      path: "/trackfy/operacao/pedido",
      name: "Pedidos",
      mini: "PED",
      component: Pedido,
      layout: "/app",
      authorized: "Pages.HUB.Pedidos",
    },
    {
      // Mesma tela do Flow › Operação › Consulta NFe. Libera com a permissão do
      // Flow OU a do Trackfy: cliente só de Trackfy não tem a do Flow.
      path: "/trackfy/operacao/notas-fiscais",
      name: "Consulta NFe",
      mini: "NFE",
      component: ConsultaNotasFiscais,
      layout: "/app",
      authorized: ["Pages.HUB.Monitoramento_NotasFiscais", "Pages.HUB.Pedidos"],
    },
    {
      // Reusa Pages.HUB.Pedidos: a busca por rastreamento/pedido pertence ao
      // mesmo grupo operacional. Permissão dedicada (Pages.HUB.Trackfy do menu
      // antigo) fica pra migração de RBAC (PO1-1947).
      path: "/trackfy/operacao/rastreamento",
      name: "Rastreamento",
      mini: "RAS",
      component: Rastreamento,
      layout: "/app",
      authorized: "Pages.HUB.Pedidos",
    },
  ],
  requiredFeatures: ["TRACKFY"],
};

// PO1-3490: Despacho também no Trackfy (Lotes e Romaneio, mesmas telas e
// permissões do Flow › Despacho). Pedidos só existe no Trackfy; sem isto o
// despacho obrigava a trocar para o Flow, e o cliente só de Trackfy não tinha
// onde fechar e despachar o lote.
const TRACKFY_DESPACHO = {
  collapse: true,
  name: "Despacho",
  icon: "tim-icons icon-delivery-fast",
  state: "trackfyDespachoCollapse",
  views: [
    {
      path: "/trackfy/despacho/lotes",
      name: "Lotes",
      mini: "LOT",
      component: DespachoLotes,
      layout: "/app",
      authorized: "hub.operacao.despacho.visualizar",
    },
    {
      path: "/trackfy/despacho/romaneio",
      name: "Romaneio",
      mini: "ROM",
      component: RomaneioManual,
      layout: "/app",
      authorized: "hub.romaneio.manual.visualizar",
    },
  ],
  requiredFeatures: ["TRACKFY"],
};

// Indicadores do Trackfy (pedido do Rodrigo, 03/10/2026): telas de
// acompanhamento, separadas das telas operacionais de consulta.
const TRACKFY_INDICADORES = {
  collapse: true,
  name: "Indicadores",
  icon: "tim-icons icon-chart-pie-36",
  state: "trackfyIndicadoresCollapse",
  views: [
    {
      // PO1-2821. Mesma permissão das telas de Operação (RBAC dedicado fica
      // pro PO1-1947). URL mantida em /operacao para não quebrar links salvos.
      path: "/trackfy/operacao/entregas-pendentes",
      name: "Entregas Pendentes",
      mini: "ENT",
      component: EntregasPendentes,
      layout: "/app",
      authorized: "Pages.HUB.Pedidos",
    },
    {
      // PO1-2926 (motor de prazo, épico PO1-2886): NFs do período sem previsão
      // de entrega, por transportadora × destino (o que falta cadastrar na
      // tabela de prazo). Mesma permissão das telas de Operação.
      path: "/trackfy/cobertura-prazo",
      name: "Cobertura do Prazo",
      mini: "COB",
      component: CoberturaPrazo,
      layout: "/app",
      authorized: "Pages.HUB.Pedidos",
    },
    {
      // PO1-3495 (épico PO1-3493): onde cada envio está entre a etiqueta e a
      // coleta. Mesma permissão de leitura de Despacho › Lotes.
      path: "/trackfy/indicadores/despacho",
      name: "Despacho",
      mini: "DES",
      component: DespachoIndicadores,
      layout: "/app",
      authorized: "hub.operacao.despacho.visualizar",
    },
  ],
  requiredFeatures: ["TRACKFY"],
};

// ─── Everlog Admin ───────────────────────────────────────────────────────────

const ADMIN_TORRE = {
  path: "/everlog/torre-controle",
  name: "Torre de Controle",
  icon: "tim-icons icon-chart-pie-36",
  component: DashboardAdmin,
  layout: "/app",
  authorized: "Pages.HUB.Dashboard",
  requiredFeatures: ["EVERLOG_ADMIN"],
};

// ─── Slices por produto ──────────────────────────────────────────────────────

// ─── MeuFrete (PO1-2287): menu do setor transportadora ─────────────────────
// Cinco itens planos. `authorized` documenta o nó hub.transportadora.* (o
// papel "Transportador | Usuário" recebe os 5 pelo script po1-2287); a trava
// real é o setor no servidor. Autopilot e Torre de Controle saíram: para a
// transportadora essas rotas respondem 403 desde a PO1-3102.
const MEUFRETE_MENU = [
  {
    path: "/meufrete/faturas",
    name: "Minhas faturas",
    icon: "tim-icons icon-single-copy-04",
    component: MinhasFaturas,
    layout: "/app",
    authorized: "hub.transportadora.faturas",
    requiredFeatures: ["MEUFRETE"],
  },
  {
    path: "/meufrete/extrato",
    name: "Extrato",
    icon: "tim-icons icon-notes",
    component: Extrato,
    layout: "/app",
    authorized: "hub.transportadora.extrato",
    requiredFeatures: ["MEUFRETE"],
  },
  {
    path: "/meufrete/envio-arquivos",
    name: "Envio de arquivos",
    icon: "tim-icons icon-cloud-upload-94",
    component: EnvioArquivos,
    layout: "/app",
    authorized: "hub.transportadora.envio",
    requiredFeatures: ["MEUFRETE"],
  },
  {
    path: "/meufrete/tabelas",
    name: "Tabelas de preço",
    icon: "tim-icons icon-paper",
    component: TabelasEnviadas,
    layout: "/app",
    authorized: "hub.transportadora.tabelas",
    requiredFeatures: ["MEUFRETE"],
  },
  // PO1-2847 (épico PO1-2413, revisão 5): a transportadora responde o BID de
  // Frete só por aqui (sem página pública). Mesma permissão das tabelas.
  {
    path: "/meufrete/bid-frete",
    name: "BID de Frete",
    icon: "tim-icons icon-paper",
    component: BidFreteTransportadora,
    layout: "/app",
    authorized: "hub.transportadora.tabelas",
    requiredFeatures: ["MEUFRETE"],
  },
  {
    path: "/meufrete/cadastro",
    name: "Cadastro",
    icon: "tim-icons icon-badge",
    component: CadastroTransportadora,
    layout: "/app",
    authorized: "hub.transportadora.cadastro",
    requiredFeatures: ["MEUFRETE"],
  },
  // PO1-3166 (20/09/2026): a esteira deixou de ser bloqueio e virou item de
  // menu. Decisão do Rodrigo: "se tem usuário e senha já deveria entrar. Tem
  // que ter um menu de embarcadores em homologação".
  //
  // "Embarcadores" e não "Habilitação": a tela lista TODOS os embarcadores dela
  // com a fase de cada um, e a maioria está operando. Quem atende cinco e entra
  // no sexto precisa ver o sexto sem que os outros sumam.
  {
    path: "/habilitacao",
    name: "Embarcadores",
    icon: "tim-icons icon-bank",
    component: Habilitacao,
    layout: "/app",
    authorized: "hub.transportadora.cadastro",
    requiredFeatures: ["MEUFRETE"],
  },
  // PO1-2309 (épico PO1-3279): a transportadora vê e gerencia a credencial SFTP
  // de cada embarcador atendido. Grupo "Integrações" no padrão de
  // SHARED_GESTAO_TRANSPORTADORAS (collapse + views), para crescer com os
  // conectores depois. Mesma permissão do Cadastro: a trava real é o setor.
  {
    collapse: true,
    name: "Integrações",
    icon: "tim-icons icon-link-72",
    state: "meufreteIntegracoesCollapse",
    views: [
      {
        path: "/meufrete/acesso-sftp",
        name: "Acesso SFTP",
        mini: "FTP",
        component: AcessoSftpMeuFrete,
        layout: "/app",
        authorized: "hub.transportadora.cadastro",
        requiredFeatures: ["MEUFRETE"],
      },
    ],
    requiredFeatures: ["MEUFRETE"],
  },
  // PO1-3505: Central de Treinamento, antes dos alertas.
  makeTreinamentoItem(PRODUCT_CODES.MEUFRETE),
  // PO1-2194: a transportadora também recebe alertas e tarefas.
  ...makeAlertasItens(PRODUCT_CODES.MEUFRETE),
];

// ─── Everlog Admin: 4 grupos + a Torre solta ───────────────────────────────
// Eram 14 itens planos, sem agrupamento e em ordem de acréscimo (o menu foi
// crescendo história a história). Reorganizado em 20/09/2026 a pedido do
// Rodrigo: "ficou muito confuso, não tem submenu, nenhuma ordem".
//
// Os grupos vão do uso diário para o raro, e cada um repete o gate de
// EVERLOG_ADMIN — o `filterNode` avalia o grupo e depois cada view, então um
// item com permissão própria (Cron Jobs, Usuários PDT, Credenciais) continua
// sumindo sozinho para quem não a tem.
//
// Nomes encurtados de propósito: dentro de "Transportadoras", "Curadoria de
// Transportadoras" vira "Curadoria". A pasta já dá o contexto.

const ADMIN_GRUPO_TRANSPORTADORAS = {
  collapse: true,
  name: "Transportadoras",
  icon: "tim-icons icon-bus-front-12",
  state: "adminTransportadorasCollapse",
  views: [
    {
      path: "/everlog/curadoria-transportadoras",
      name: "Curadoria",
      mini: "CUR",
      component: CuradoriaTransportadoras,
      layout: "/app",
      authorized: "Pages.HUB.Dashboard",
    },
    {
      path: "/everlog/homologacao-transportadoras",
      name: "Homologação",
      mini: "HOM",
      component: HomologacaoTransportadoras,
      layout: "/app",
      authorized: "Pages.HUB.Dashboard",
    },
    // PO1-3282: era "Acesso SFTP"; virou o Onboarding de Transportadora (cadastro,
    // contatos, homologação, pastas, usuário SFTP e portal). O path fica.
    {
      path: "/everlog/acesso-sftp-transportadora",
      name: "Onboarding de Transportadora",
      mini: "ONB",
      component: AcessoSftpTransportadora,
      layout: "/app",
      authorized: "Pages.HUB.Dashboard",
    },
    {
      path: "/everlog/tabelas-enviadas",
      name: "Tabelas enviadas",
      mini: "TAB",
      component: TabelasEnviadasAdmin,
      layout: "/app",
    },
    // PO1-3649 (épico PO1-3359): funil da Rede Everlog, do pedido público à
    // transportadora vinculada por um embarcador real.
    {
      path: "/everlog/rede-everlog-funil",
      name: "Funil da Rede",
      mini: "RED",
      component: RedeEverlogFunil,
      layout: "/app",
      authorized: "Pages.HUB.Dashboard",
    },
    // Cadastro mestre (PO1-3168): veio dos menus de produto, ver a declaração.
    ADMIN_CADASTRO_TRANSPORTADORAS,
  ],
  requiredFeatures: ["EVERLOG_ADMIN"],
};

// Credenciais entra aqui pela decisão do Rodrigo em 20/09 ("é do embarcador, eu
// acho... pode deixar em Embarcadores e depois vemos"): o path `/configuracoes/`
// destoa dos demais e é resíduo histórico, a revisar.
const ADMIN_GRUPO_EMBARCADORES = {
  collapse: true,
  name: "Embarcadores",
  icon: "tim-icons icon-bank",
  state: "adminEmbarcadoresCollapse",
  views: [
    {
      path: "/everlog/companies",
      name: "Embarcadores",
      mini: "EMB",
      component: Companies,
      layout: "/app",
      authorized: "Pages.HUB.Dashboard",
    },
    {
      path: "/everlog/onboarding-embarcador",
      name: "Onboarding",
      mini: "ONB",
      component: OnboardingEmbarcador,
      layout: "/app",
      authorized: "Pages.HUB.Dashboard",
    },
    {
      path: "/everlog/produtos-embarcador",
      name: "Produtos",
      mini: "PRD",
      component: EmbarcadoresProdutos,
      layout: "/app",
      authorized: "Pages.HUB.Dashboard",
    },
    {
      path: "/configuracoes/credenciais",
      name: "Credenciais",
      mini: "CRD",
      component: Credenciais,
      layout: "/app",
      authorized: "Pages.HUB.Acessos.Credenciais",
    },
  ],
  requiredFeatures: ["EVERLOG_ADMIN"],
};

const ADMIN_GRUPO_CATALOGOS = {
  collapse: true,
  name: "Catálogos",
  icon: "tim-icons icon-book-bookmark",
  state: "adminCatalogosCollapse",
  views: [
    {
      path: "/everlog/catalogo-parametros",
      name: "Parâmetros",
      mini: "PAR",
      component: CatalogoParametros,
      layout: "/app",
      authorized: "Pages.HUB.Dashboard",
    },
    {
      path: "/everlog/catalogo-conectores",
      name: "Conectores",
      mini: "CON",
      component: ConectoresCatalogo,
      layout: "/app",
      authorized: "Pages.HUB.Dashboard",
    },
    // PO1-2194: catálogo do motor de alertas.
    {
      path: "/everlog/catalogo-alertas",
      name: "Alertas",
      mini: "ALE",
      component: AlertasCatalogo,
      layout: "/app",
      authorized: "hub.alertas.catalogo.gerenciar",
    },
    // PO1-3103: catálogo global (cadastro base + tipos exclusivos por cliente,
    // PO1-3489), então mora no Everlog Admin e não em Cadastros Gerais. O grant é
    // um hub.* que ninguém recebe: só o admin entra (bypass), inclusive pela URL.
    {
      path: "/everlog/catalogo-tipos-veiculo",
      name: "Tipos de Veículo",
      mini: "TPV",
      component: TiposVeiculo,
      layout: "/app",
      authorized: "hub.cadastros.tipoVeiculo.editar",
    },
    // PO1-3505: catálogo de tutoriais da Central de Treinamento. Só o admin
    // Everlog cadastra (o backend devolve 403 aos demais); o grant é um hub.*
    // que ninguém recebe, então só o admin vê o item (bypass), inclusive pela URL.
    {
      path: "/everlog/catalogo-tutoriais",
      name: "Tutoriais",
      mini: "TUT",
      component: CatalogoTutoriais,
      layout: "/app",
      authorized: "hub.treinamento.catalogo.gerenciar",
    },
  ],
  requiredFeatures: ["EVERLOG_ADMIN"],
};

// Sprint 638: cadastros GLOBAIS (valem para todos os clientes) são editados só
// aqui. Nos produtos do cliente CEP, Modais e Tipo de Serviço aparecem só para
// consulta e Taxas de Frete nem aparece. O grant é um hub.* que ninguém recebe:
// só o admin entra (bypass), inclusive pela URL; o backend nega a escrita a quem
// não é admin Everlog (exigirAdminEverlog).
const ADMIN_GRUPO_CADASTROS_GLOBAIS = {
  collapse: true,
  name: "Cadastros globais",
  icon: "tim-icons icon-world",
  state: "adminCadastrosGlobaisCollapse",
  views: [
    {
      path: "/everlog/cadastros-globais/cep",
      name: "CEP",
      mini: "CEP",
      component: CadastrosGerais,
      layout: "/app",
      authorized: "hub.cadastros.globais.editar",
    },
    {
      path: "/everlog/cadastros-globais/modais",
      name: "Modais",
      mini: "MOD",
      component: Modais,
      layout: "/app",
      authorized: "hub.cadastros.globais.editar",
    },
    {
      path: "/everlog/cadastros-globais/tipos-servico",
      name: "Tipos de Serviço",
      mini: "TPS",
      component: TiposServicoAdmin,
      layout: "/app",
      authorized: "hub.cadastros.globais.editar",
    },
    {
      path: "/everlog/cadastros-globais/taxas-frete",
      name: "Taxas de Frete",
      mini: "TXF",
      component: TaxasFrete,
      layout: "/app",
      authorized: "hub.cadastros.globais.editar",
    },
  ],
  requiredFeatures: ["EVERLOG_ADMIN"],
};

const ADMIN_GRUPO_AJUSTES = {
  collapse: true,
  name: "Ajustes",
  icon: "tim-icons icon-settings-gear-63",
  state: "adminAjustesCollapse",
  views: [
    {
      path: "/everlog/cronjobs",
      name: "Cron jobs",
      mini: "CRN",
      component: Cronjobs,
      layout: "/app",
      authorized: "hub.admin.cronjobs.read",
    },
    // PO1-3295: vieram da "Gestão de Acessos" dos produtos de cliente. Mesmos
    // paths, para não quebrar link salvo de quem é admin.
    {
      path: "/acessos/roles",
      name: "Gerenciar Grupos",
      mini: "ROL",
      component: Roles,
      layout: "/app",
      authorized: "Pages.HUB.Users",
    },
    {
      path: "/acessos/configuracoes",
      name: "Configurações",
      mini: "CFG",
      component: Settings,
      layout: "/app",
      authorized: "Pages.HUB.Users",
    },
  ],
  requiredFeatures: ["EVERLOG_ADMIN"],
};

// Telas que ninguém tem certeza se ainda servem. Ficam VISÍVEIS, num grupo com
// nome que avisa, em vez de sumirem do menu: este produto é interno (só Everlog),
// então o custo de deixar à vista é baixo e some o risco de esquecer que existem.
// Decisão do Rodrigo em 20/09/2026: "dá para desligar do menu, mas não apagar do
// código? ou melhor deixar no menu em algo como OLD, ou REVISAR".
//
// O que se sabe de cada uma (contexto dele, que não dá para deduzir do código):
//   Usuários PDT           usuários do Portal do Transportador ANTIGO, o de PHP,
//                          anterior ao MeuFrete (PO1-2285).
//   Integração e-commerce  feita para um cliente antigo, da Klabin; sem definição
//                          sobre reaproveitar.
//
// Nada foi apagado: componentes, rotas e permissões seguem no código. Antes de
// remover de vez, lembrar que zero tráfego não prova código morto — pode ser
// produto parado. Conferir uso real primeiro.
const ADMIN_GRUPO_REVISAR = {
  collapse: true,
  name: "Revisar",
  icon: "tim-icons icon-alert-circle-exc",
  state: "adminRevisarCollapse",
  views: [
    {
      path: "/everlog/usuarios-pdt",
      name: "Usuários PDT (portal antigo)",
      mini: "PDT",
      component: UsuariosPDT,
      layout: "/app",
      authorized: "Pages.HUB.PortalTransportador.Usuarios",
    },
    {
      path: "/everlog/integracao-ecommerce",
      name: "Integração e-commerce",
      mini: "ECM",
      component: EcommerceIntegration,
      layout: "/app",
      authorized: "Pages.HUB.Dashboard",
    },
  ],
  requiredFeatures: ["EVERLOG_ADMIN"],
};

// Ordem reflete a ordem visual no menu lateral. Autopilot é sempre o
// primeiro item — ponto de entrada do user (consistente com o pinnedRouteOrder
// antigo do Admin.js, que mantinha Autopilot=0).
export const PRODUCT_MENUS = {
  [PRODUCT_CODES.FLOW]: [
    SHARED_AUTOPILOT,
    FLOW_DASHBOARD,
    FLOW_MEU_PAINEL,
    FLOW_INDICADORES,
    FLOW_CONSULTAS,
    FLOW_OPERACAO,
    FLOW_FINANCEIRO,
    FLOW_DESPACHO,
    FLOW_SUSTENTACAO,
    SHARED_TABELAS_FRETE,
    SHARED_GESTAO_TRANSPORTADORAS,
    SHARED_INTEGRACOES,
    SHARED_EMBARCADORES,
    FLOW_IMPOSTOS,
    SHARED_CADASTROS_GERAIS,
    SHARED_PARAMETROS,
    SHARED_ACESSOS,
    makeTreinamentoItem(PRODUCT_CODES.FLOW),
    ...makeAlertasItens(PRODUCT_CODES.FLOW),
  ],
  [PRODUCT_CODES.GOBID]: [
    SHARED_AUTOPILOT,
    GOBID_DASHBOARD,
    GOBID_MEU_PAINEL,
    // PO1-3629: Operação antes de Indicadores (decisão 8 do kickoff).
    GOBID_OPERACAO,
    GOBID_INDICADORES,
    SHARED_GESTAO_TRANSPORTADORAS,
    SHARED_TABELAS_FRETE,
    SHARED_EMBARCADORES,
    SHARED_CADASTROS_GERAIS,
    SHARED_INTEGRACOES,
    SHARED_PARAMETROS,
    SHARED_ACESSOS,
    makeTreinamentoItem(PRODUCT_CODES.GOBID),
    ...makeAlertasItens(PRODUCT_CODES.GOBID),
  ],
  [PRODUCT_CODES.TRACKFY]: [
    SHARED_AUTOPILOT,
    TRACKFY_DASHBOARD,
    TRACKFY_MEU_PAINEL,
    TRACKFY_OPERACAO,
    TRACKFY_DESPACHO,
    TRACKFY_INDICADORES,
    SHARED_GESTAO_TRANSPORTADORAS,
    SHARED_EMBARCADORES,
    TRACKFY_FERIADOS,
    SHARED_CADASTROS_GERAIS,
    SHARED_INTEGRACOES,
    SHARED_PARAMETROS,
    SHARED_ACESSOS,
    makeTreinamentoItem(PRODUCT_CODES.TRACKFY),
    ...makeAlertasItens(PRODUCT_CODES.TRACKFY),
  ],
  [PRODUCT_CODES.AUTOPILOT]: [
    SHARED_AUTOPILOT,
    makeTreinamentoItem(PRODUCT_CODES.AUTOPILOT),
    ...makeAlertasItens(PRODUCT_CODES.AUTOPILOT),
  ],
  [PRODUCT_CODES.EVERLOG_ADMIN]: [
    ADMIN_TORRE,
    ADMIN_GRUPO_TRANSPORTADORAS,
    ADMIN_GRUPO_EMBARCADORES,
    ADMIN_GRUPO_CATALOGOS,
    ADMIN_GRUPO_CADASTROS_GLOBAIS,
    ADMIN_GRUPO_AJUSTES,
    ADMIN_GRUPO_REVISAR,
    // PO1-3505 (decisão 11 do kickoff): a Central também no Everlog Admin, que
    // vê todos os tutoriais. Fica solta no fim, como nos outros produtos.
    makeTreinamentoItem(PRODUCT_CODES.EVERLOG_ADMIN),
  ],
  [PRODUCT_CODES.MEUFRETE]: MEUFRETE_MENU,
};

// Redirects (PO1-1975, PR 1) — paths antigos continuam funcionando pra
// bookmarks e links externos. Cada Redirect é renderizado no Switch do
// AdminLayout ANTES de getRoutes(), pra que o Router resolva o redirect
// antes de tentar achar a rota nova.
export const LEGACY_REDIRECTS = [
  // Compartilhados (afetam Flow + GoBid + Trackfy)
  { from: "/app/transportadoras", to: "/app/cadastros/transportadoras" },
  { from: "/app/tabelas-frete", to: "/app/cadastros/tabelas-frete" },
  { from: "/app/nova-tabela-frete", to: "/app/cadastros/tabelas-frete/nova" },
  { from: "/app/flw/frete-tabela/import-xlsm", to: "/app/cadastros/tabelas-frete/importar" },
  { from: "/app/cadastros-gerais/embarcadores", to: "/app/cadastros/embarcadores" },
  { from: "/app/cadastros-gerais/cep", to: "/app/cadastros/cep" },
  { from: "/app/cadastros-gerais/modais", to: "/app/cadastros/modais" },
  { from: "/app/cadastros/negocio", to: "/app/cadastros/negocios" },
  { from: "/app/cadastros-gerais/negocio", to: "/app/cadastros/negocios" },
  { from: "/app/cadastros-gerais/negocios", to: "/app/cadastros/negocios" },
  { from: "/app/cadastros-gerais/tipos-servico", to: "/app/cadastros/tipos-servico" },
  // Taxas de Frete só no Everlog Admin (sprint 638): o admin cai na tela de lá;
  // para os demais a rota do admin não existe no menu e o guard leva à inicial.
  { from: "/app/cadastros-gerais/taxas-frete", to: "/app/everlog/cadastros-globais/taxas-frete" },
  { from: "/app/cadastros/taxas-frete", to: "/app/everlog/cadastros-globais/taxas-frete" },
  { from: "/app/cadastros-gerais/vincular-tipo-servico", to: "/app/cadastros/vincular-tipo-servico" },
  { from: "/app/flw/holidays", to: "/app/cadastros/feriados" },
  { from: "/app/parametros/embarcador", to: "/app/configuracoes/parametros-embarcador" },
  { from: "/app/parametros/transportadora", to: "/app/configuracoes/parametros-transportadora" },
  { from: "/app/parametros/remetente", to: "/app/configuracoes/parametros-remetente" },
  { from: "/app/acessos/credenciais", to: "/app/configuracoes/credenciais" },
  { from: "/app/acessos/users", to: "/app/acessos/usuarios" },
  // Flow exclusivo
  { from: "/app/auditoria/cte", to: "/app/flow/operacao/auditoria-cte" },
  { from: "/app/notasFiscais", to: "/app/flow/operacao/notas-fiscais" },
  { from: "/app/recalcular", to: "/app/flow/operacao/recalcular" },
  // A Pesquisa Importação virou a Consulta NFe (31/10/2026); a query string
  // (filtros) é preservada pelo AdminLayout.
  { from: "/app/flow/operacao/pesquisa-importacao", to: "/app/flow/operacao/notas-fiscais" },
  // Sprint 638: Origens / CDs e Contatos viraram abas do cadastro do embarcador.
  { from: "/app/configuracoes/origens", to: "/app/cadastros/embarcadores", search: { aba: "origens" } },
  { from: "/app/configuracoes/contatos-embarcador", to: "/app/cadastros/embarcadores", search: { aba: "contatos" } },
  { from: "/app/indicadores/faturamento", to: "/app/flow/indicadores/faturamento" },
  { from: "/app/indicadores/emissoes-carbono", to: "/app/flow/indicadores/emissoes-carbono" },
  { from: "/app/indicadores/piso-antt", to: "/app/flow/indicadores/piso-antt" },
  { from: "/app/sustentacao/upload-transportador", to: "/app/flow/sustentacao/upload-transportador" },
  { from: "/app/sustentacao/upload-embarcador", to: "/app/flow/sustentacao/upload-embarcador" },
  { from: "/app/fiscal/tributos-estaduais", to: "/app/flow/fiscal/tributos-estaduais" },
  { from: "/app/fiscal/tributos-municipais", to: "/app/flow/fiscal/tributos-municipais" },
  // Romaneio saiu de Operação para o grupo Despacho; a fatura manual virou o
  // modal "Nova fatura" da Auditoria de Faturas.
  { from: "/app/flow/operacao/romaneio-manual", to: "/app/flow/despacho/romaneio" },
  { from: "/app/flow/operacao/criar-fatura", to: "/app/flow/operacao/auditoria-faturas" },
  // NFse sem notas saiu de Operação para Sustentação (06/10/2026).
  { from: "/app/flow/operacao/nfse-sem-notas", to: "/app/flow/sustentacao/nfse-sem-notas" },
  // /app/dashboard era usado tanto pelo Flow (setor=empresa) quanto pelo
  // Everlog Admin. Redireciona pro Flow por default — admin chega no Everlog
  // pelo app switcher de qualquer forma.
  { from: "/app/dashboard", to: "/app/flow/dashboard" },
  // GoBid (PR 2)
  { from: "/app/nova-cotacao", to: "/app/gobid/operacao/nova-cotacao" },
  { from: "/app/cotacao-lote", to: "/app/gobid/operacao/cotacao-em-lote" },
  { from: "/app/listagem-cotacoes", to: "/app/gobid/operacao/listagem-cotacoes" },
  // PO1-3629: "Dashboards" virou "Indicadores" e a Fila de Fretes foi para
  // Operação. Links já enviados a clientes e manuais continuam abrindo.
  { from: "/app/gobid/dashboards/savings", to: "/app/gobid/indicadores/savings" },
  { from: "/app/gobid/dashboards/fila-fretes", to: "/app/gobid/operacao/fila-fretes" },
  { from: "/app/gobid", to: "/app/gobid/operacao/listagem-cotacoes" }, // era gobid-legado (descontinuado)
  // Trackfy (PR 3)
  { from: "/app/pedidos", to: "/app/trackfy/operacao/pedido" },
  // Everlog Admin (PR 4)
  { from: "/app/admin/companies", to: "/app/everlog/companies" },
  { from: "/app/pdt/usuarios", to: "/app/everlog/usuarios-pdt" },
  { from: "/app/admin/parametros", to: "/app/everlog/catalogo-parametros" },
  { from: "/app/admin/ecommerce", to: "/app/everlog/integracao-ecommerce" },
  { from: "/app/admin/cronjobs", to: "/app/everlog/cronjobs" },
  // MeuFrete (PO1-2287): o Extrato da transportadora mudou de endereço.
  { from: "/app/extrato", to: "/app/meufrete/extrato" },
];

// Aterrissagem única (PO1-2287): transportadora → Minhas faturas; os demais →
// Autopilot. Usada no layout, no Route público, nas telas de conta e no painel.
//
// PO1-3166 (20/09/2026): deixou de desviar para /app/habilitacao. "Se tem
// usuário e senha, entra no portal normal" — quem está em onboarding cai nas
// faturas como qualquer outra, e acompanha a esteira pelo menu Embarcadores.
export function rotaInicial(user) {
  if (user && user.setor === "transportadora") return "/app/meufrete/faturas";
  return "/app/autopilot";
}

// ─── Helpers ─────────────────────────────────────────────────────────────────

// Retorna os produtos visíveis no app switcher dado o set de features
// contratadas do user. Itens AUTOPILOT-only não viram "produto" no switcher
// (Autopilot é compartilhado, aparece no menu lateral).
// EVERLOG_ADMIN entra quando vem em features (backend já manda pra setor=admin).
export function getSwitcherProducts(features) {
  const out = [];
  if (!features || typeof features.has !== "function") return out;
  PRODUCT_ORDER.forEach((code) => {
    if (code === PRODUCT_CODES.AUTOPILOT) return; // não vai no switcher
    if (features.has(code)) out.push({ code, ...PRODUCT_META[code] });
  });
  return out;
}

// Filtra a árvore de menu do produto ativo contra Features + Permissions.
// Mantém estrutura original (collapse/views/icon/etc) — Sidebar continua igual.
// Query do redirect legado: mantém a query de quem chegou e completa com a do
// redirect (ex.: ?aba=origens) sem sobrescrever o que já veio na URL.
export function buscaDoRedirect(redirect, search) {
  const params = new URLSearchParams(search || "");
  const extra = (redirect && redirect.search) || {};
  Object.keys(extra).forEach((k) => {
    if (!params.has(k)) params.set(k, extra[k]);
  });
  const texto = params.toString();
  return texto ? `?${texto}` : "";
}

export function filterMenuForUser(productCode, { features, permissions, isAdmin }) {
  const tree = PRODUCT_MENUS[productCode] || [];
  return tree
    .map((item) => filterNode(item, { features, permissions, isAdmin }))
    .filter(Boolean);
}

// Procura a tela atual na árvore do produto e retorna o nome do grupo (collapse
// pai, se houver) + nome da tela. Usado pelo ProductBreadcrumb no header.
// Retorna { groupName: string|null, screenName: string|null }.
export function findBreadcrumbInProduct(productCode, pathname) {
  const tree = PRODUCT_MENUS[productCode] || [];
  for (const item of tree) {
    if (item.collapse && Array.isArray(item.views)) {
      const child = item.views.find((v) => casaPath(v, pathname));
      if (child) return { groupName: item.name, screenName: child.name };
    } else if (casaPath(item, pathname)) {
      return { groupName: null, screenName: item.name };
    }
  }
  return { groupName: null, screenName: null };
}

// Item com `matchExact` só casa o caminho inteiro; os demais (inclusive os que
// têm `exact` só para o <Route>) casam por prefixo, como sempre foi. Sem isto
// /app/autopilot/alertas mostraria "Autopilot" no breadcrumb (PO1-2194).
function casaPath(node, pathname) {
  if (!node.layout) return false;
  const full = node.layout + node.path;
  if (node.matchExact) return pathname === full || pathname === `${full}/`;
  return pathname.indexOf(full) !== -1;
}

function nodeMatchesFeatures(node, features) {
  if (!node.requiredFeatures || node.requiredFeatures.length === 0) return true;
  return node.requiredFeatures.some((f) => features.has(f));
}

// `authorized` aceita uma permissão ou uma lista (qualquer uma libera): mesma
// tela publicada em dois produtos, cada um com a sua permissão. O backend
// aceita a mesma lista na rota (authorize([...])).
//
// Exportada (PO1-2381): é a MESMA regra do guard de URL em routes/Route.js —
// quem vê o item no menu entra pela URL; quem não vê recebe "Sem acesso".
export function nodeMatchesPermission(node, permissions, isAdmin) {
  if (isAdmin) return true;
  if (!node.authorized) return true;
  const aceitas = Array.isArray(node.authorized) ? node.authorized : [node.authorized];
  return aceitas.some((permissao) => (permissions || []).includes(permissao));
}

// Árvore do produto filtrada só por feature (PO1-2381): é o que vira <Route> no
// Admin. A permissão fica para o guard de URL (Route.js, `authorized`), que
// mostra "Sem acesso" em vez de redirecionar em silêncio. O menu continua
// vindo de filterMenuForUser (feature + permissão).
export function rotasDoProduto(productCode, { features }) {
  const tree = PRODUCT_MENUS[productCode] || [];
  return tree
    .map((item) => filterNode(item, { features, permissions: [], isAdmin: true }))
    .filter(Boolean);
}

function filterNode(node, ctx) {
  if (!nodeMatchesFeatures(node, ctx.features)) return null;

  if (node.collapse) {
    const views = (node.views || [])
      .map((view) => filterNode(view, ctx))
      .filter(Boolean);
    if (views.length === 0) return null;
    return { ...node, views };
  }

  if (!nodeMatchesPermission(node, ctx.permissions, ctx.isAdmin)) return null;
  return node;
}
